<template>
    <el-dialog
            v-bind="{ ...$props, ...$attrs }"
            v-on="$listeners"
            append-to-body
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :width="dialogWidth"
            :title="formTitle"
            :before-close="closeDialog"

    >
        <div style="text-align: right;margin-bottom: 20px">
            <div class="search-bar">
                <el-input :placeholder="placeholder" clearable v-model="queryStr"></el-input>
                <el-button size="small" icon="el-icon-search" type="primary" @click="searchByParams">查询</el-button>
            </div>
        </div>
        <el-table
                v-if="columns && columns.length"
                v-bind="{ ...$props, ...$attrs }"
                v-on="$listeners"
                ref="treeSelect"
                class="dataTable"
                border
                size="small"
                stripe
                style="width: 100%"
                :max-height="maxHeight"
                :data="tableData"
                tooltip-effect="dark"
                @selection-change="handleSelectionChange"
        >
            <el-table-column v-if="selectionFlag"
                             type="selection"
                             width="40"
            >
            </el-table-column>
            <el-table-column v-for="(label,index) in columns"
                             sortable
                             show-overflow-tooltip
                             :key="index"
                             :label="label.label"
                             :prop="label.prop">
            </el-table-column>
        </el-table>
        <el-pagination
                v-if="tableData && tableData.length"
                background
                @size-change="paginationChange('size', $event)"
                @current-change="paginationChange('page', $event)"
                :page-sizes="pageSizes"
                :current-page="pagination.page"
                :page-size="pagination.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total"
                @change="paginationChange('size', $event)"
        >
        </el-pagination>
        <div slot="footer" style="margin-top:4px;text-align: right">
            <el-button v-if="tableData && tableData.length" type="danger" size="mini" icon="el-icon-check"
                       @click="confirmDialog">确认
            </el-button>
            <el-button size="mini" icon="el-icon-close" plain type="primary" @click="closeDialog">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: 'tree-select',
        props: {
            action: {
                type: String,
                default: ''
            },
            maxHeight: {
                type: Number,
                default: 400,
            },
            tableData: {
                type: Array,
                default: () => [],
            },
            selectionFlag: {
                type: Boolean,
                default: true,
            },
            columns: {
                required: true,
                type: Array,
                default: () => [],
            },
            dialogWidth: {
                type: String,
                default: '900px',
            },
            formTitle: {
                type: String,
                default: '选择',
            },
            dialogVisible: {
                type: Boolean,
                default: false
            },
            isRadio: {
                type: Boolean,
                default: true
            },
            pagination: {
                type: Object,
                default: () => {
                    return {
                        total: 0,
                        page: 1,
                        size: 20,
                    }
                },
            },
            placeholder: {
                type: String,
                default: '请输入内容'
            }
        },
        data() {
            return {
                pageSizes: [10, 20, 50, 100],
                multipleSelection: [],
                queryStr: ''
            };
        },
        filters: {},
        methods: {
            paginationChange(key, data) {
                const {page, size} = this.pagination;
                const tempData = {page, size};
                tempData[key] = data;
                if (key === 'size') {
                    tempData.page = 1
                }
                this.$emit('paginationChange', {tempData, query: this.queryStr, action: this.action});
            },
            confirmDialog() {
                this.$emit('confirm', {
                    selection: this.multipleSelection
                });
                this.queryStr = '';
                this.$refs.treeSelect.clearSelection();
            },
            closeDialog() {
                this.$emit('close');
                this.queryStr = '';
                this.$refs.treeSelect.clearSelection();
            },
            searchByParams() {
                this.$emit('remoteMethod', {query: this.queryStr, action: this.action})
            },
            handleSelectionChange(selection) {
                if (this.isRadio && selection.length > 1) {
                    this.$refs.treeSelect.clearSelection();
                    this.$refs.treeSelect.toggleRowSelection(selection.pop());
                } else {
                    this.multipleSelection = selection;
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    ::v-deep .el-dialog {
        .el-dialog__header {
            padding-top: 10px;
            background: linear-gradient(135deg, #0cd7bd 10%, #50c3f7);
            .el-dialog__title {
                color: white;
            }
            .el-dialog__headerbtn {
                top: 15px;
                .el-dialog__close {
                    color: white;
                }
            }
        }
        .el-dialog__body {
            padding: 8px 12px !important;
        }
    }

    //隐藏全选框
    ::v-deep .search-bar {
        display: flex;
        align-items: center;
        .el-input {
            margin-right: 10px;
            .el-input__inner {
                width: 200px !important;
                line-height: 32px !important;
                height: 32px !important;
            }
            .el-input__suffix {
                top: -2px;
            }
        }
    }

    .dataTable {
        ::v-deep .el-table__header-wrapper {
            .el-table__header {
                .el-table__cell {
                    padding: 2px 0 !important;
                }
            }
        }

        ::v-deep .el-table__body-wrapper {
            height: 100% !important;
            .el-table__empty-block {
                //width: 100% !important;
            }
            .el-table__body {
                .el-table__row {
                    .el-table__cell {
                        padding: 2px 0 !important;
                    }
                }
            }
        }
        ::v-deep .el-table__fixed {
            .el-table__fixed-header-wrapper {
                .el-table__header {
                    .el-table__cell {
                        padding: 2px 0 !important;
                    }
                }
            }
            .el-table__fixed-body-wrapper {
                .el-table__body {
                    .el-table__row {
                        .el-table__cell {
                            padding: 2px 0 !important;
                        }
                    }
                }
            }
        }
    }
</style>
